const { default: Overlay } = await import('@components/overlays')

export default class Menu extends Overlay {
    constructor(menu, button) {
        super(menu, {
            stackable: true
        })

        this.button = button

        this.button.addEventListener('click', this.toggle)
    }

    open() {
        super.open()

        this.button.setAttribute('aria-expanded', true)
    }

    close() {
        super.close()

        this.button.setAttribute('aria-expanded', false)

        dispatchEvent(new CustomEvent('closesubmenus'))
    }
}

/*-------- Language toggle --------*/
$('.language-toggle, .language-menu .arrow-svg').on('click', function () {
    var $menu = $(this).closest('.language-menu'); // Trouve le conteneur du menu
    $menu.find('.language-toggle').toggleClass('active');
    $menu.find('.language-toggle').attr('aria-expanded', function (i, attr) {
        return attr === 'true' ? 'false' : 'true';
    });
    $menu.find('.language-list').slideToggle();
    $menu.find('.language-menu .arrow-svg').toggleClass('active');
});

/*-------- Submenus --------*/
const submenus = document.querySelectorAll('.submenu')

if (submenus.length) {
    const { default: Submenu } = await import('@components/submenus')

    submenus.forEach(submenu => new Submenu(submenu, submenu.previousElementSibling))

    addEventListener('opening', e => {
        if (e.target.classList.contains('submenu')) {
            document.body.style.setProperty('--submenu-h', `${e.target.offsetHeight}px`)
        }
    })

    addEventListener('closing', e => {
        if (e.target.classList.contains('submenu')) {
            document.body.style.setProperty('--submenu-h', '')
        }
    })
}

/*-------- Scroll menu --------*/
$(window).on('load scroll', function () {
    $('header').toggleClass('scrolled', $(this).scrollTop() > 30);
});


var lastScrollTop = 0;
$(window).on('scroll', function() {
    var scrollTop = $(this).scrollTop();
    if (scrollTop > 100) {
        if (scrollTop > lastScrollTop) {
            $('.header').addClass('hidden');
        } else {
            $('.header').removeClass('hidden');
        }
    }
    lastScrollTop = scrollTop;
});